(() => {
  'use strict';
  class PutzkopfCart {
    constructor({ root = '/', onChange = () => {}, onBusy = () => {} } = {}) {
      this.root = root.endsWith('/') ? root : root + '/';
      this.onChange = onChange;
      this.onBusy = onBusy;
      this.tail = Promise.resolve();
      this.pending = 0;
    }
    async request(path, payload) {
      const response = await fetch(this.root + path, {
        method: payload === undefined ? 'GET' : 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        ...(payload === undefined ? {} : { body: JSON.stringify(payload) })
      });
      let data;
      try { data = await response.json(); }
      catch { throw new Error('Der Warenkorb konnte nicht geladen werden. Bitte versuche es erneut.'); }
      if (!response.ok) throw new Error(data.description || data.message || 'Shopify konnte den Warenkorb nicht aktualisieren.');
      return data;
    }
    queue(task) {
      this.pending += 1;
      this.onBusy(true);
      const result = this.tail.then(task);
      this.tail = result.catch(() => {});
      return result.finally(() => {
        this.pending -= 1;
        this.onBusy(this.pending > 0);
      });
    }
    async refresh() {
      const cart = await this.request('cart.js');
      this.onChange(cart);
      return cart;
    }
    load() { return this.queue(() => this.refresh()); }
    add(id, quantity) {
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isInteger(quantity) || quantity < 1) {
        return Promise.reject(new Error('Bitte wähle einen verfügbaren Artikel und eine gültige Menge.'));
      }
      return this.queue(async () => {
        await this.request('cart/add.js', { items: [{ id, quantity }] });
        return this.refresh();
      });
    }
    change(key, quantity) {
      if (!key || !Number.isInteger(quantity) || quantity < 0) return Promise.reject(new Error('Ungültige Warenkorbmenge.'));
      return this.queue(async () => {
        const cart = await this.request('cart/change.js', { id: key, quantity });
        this.onChange(cart);
        return cart;
      });
    }
  }
  window.PutzkopfCart = PutzkopfCart;
})();
